import { NavItemBase, NAV_ITEM_TYPE, NavItemType } from './nav-item-base';
import { NavGroup } from './nav-group';

export class NavLink extends NavItemBase {
  /**
   * The link this item points to.
   * Note that the final path is generated from ancestors.
   */
  link: string | any[];

  get url(): string {
    let prefix = this.parent ? this.parent.url : '';

    if (prefix) {
      prefix += '/';
    }
    return prefix + this.link;
  }

  constructor(parent?: NavGroup) {
    super(NAV_ITEM_TYPE.Link, parent);
  }

  static IS_NAV_LINK(item: NavItemType): item is NavLink {
    return item && item.type === NAV_ITEM_TYPE.Link;
  }

  static createFrom(obj: Partial<NavLink>, parent?: NavGroup): NavLink {
    const navLink = new NavLink(parent);
    Object.assign(navLink, obj);
    return navLink;
  }
}
